import OrganisationTagService from './OrganisationTagService'
import LocalStorageService from './LocalStorageService'

import constants from '../utils/constants'

// const hideValues = false
const apiToken = LocalStorageService.get('apiToken')

export const recordTerms = [
  { key: 'physicalReportTerm', label: 'Physical Intervention Report' },
  { key: 'incidentReportTerm', label: 'Incident Report' },
  { key: 'smartPlanBuilderTerm', label: 'Smart Plan Builder' },
  { key: 'communicationTerm', label: 'Behaviour Communications' }
]

export const getRecordTerm = (terms, key, fallback) => terms?.[key]?.trim() || fallback

class TermsService {

  getPILTerms = async () => {
    const params = {
      fields: 'type,key,value'
    }

    const where = {
      type: 'besmart'
    }

    const organisationTags = await OrganisationTagService.get(apiToken, params, where)


  }

  getCommonTerms = async () => {
    const apiToken = LocalStorageService.get('apiToken')
    const activeOrg = LocalStorageService.get('activeOrg')
    const params = {
      fields: 'type,key,value',
      orgId: activeOrg?.id
    }

    const where = {
      type: 'besmart'
    }

    // Default term
    var serviceUserTerm = {
      value: 'service user'
    }

    var serviceUserTermPlural = {
      value: 'service users'
    }

    var serviceTerm = {
      value: 'service'
    }

    var serviceTermPlural = {
      value: 'services'
    }

    const organisationTags = await OrganisationTagService.get(apiToken, params, where)

    // Override terms if set
    if (organisationTags) {
      serviceUserTerm = organisationTags.find(tag => (tag.type === 'besmart' && tag.key === 'serviceUserTerm'))
      serviceUserTermPlural = organisationTags.find(tag => (tag.type === 'besmart' && tag.key === 'serviceUserTermPlural'))
      serviceTerm = organisationTags.find(tag => (tag.type === 'besmart' && tag.key === 'serviceTerm'))
      serviceTermPlural = organisationTags.find(tag => (tag.type === 'besmart' && tag.key === 'serviceTermPlural'))
    }

    var updatedTerms = {}
    if (serviceUserTerm?.value) {
      updatedTerms.serviceUser = serviceUserTerm.value
    }

    if (serviceUserTermPlural?.value) {
      updatedTerms.serviceUserPlural = serviceUserTermPlural.value
    }

    if (serviceTerm?.value) {
      updatedTerms.service = serviceTerm.value
    }

    if (serviceTermPlural?.value) {
      updatedTerms.serviceTerm = serviceTermPlural.value
    }

    recordTerms.forEach(({ key }) => {
      const value = organisationTags?.find(tag => tag.type === 'besmart' && tag.key === key)?.value
      if (value?.trim()) updatedTerms[key] = value.trim()
    })

    // set default values for PIL terms if needed
    constants?.pilKeys?.forEach(pilTerm => {
      if (!pilTerm.key) return

      const orgTag = organisationTags?.find(
        tag => tag.key === this.getPILTermKeyToTagKey(pilTerm.key)
      )
      updatedTerms[pilTerm.key] = orgTag?.value || pilTerm.label
    })
    return updatedTerms
  }
  getPILTermKeyToTagKey = (termKey) => {
    const key = termKey?.slice(0, 20) + 'Term'
    return key || null
  }
}
export default new TermsService()
